import { Directive, OnInit } from '@angular/core';
import { VirtualFolder } from '@modules/calendar-app/types/virtual-folder';
import { Application } from '@modules/common/types/application';
import { StateKey } from '@modules/settings/types/state-key';
import { EventsContextMenuComponent } from '../components/events-context-menu/events-context-menu.component';
import { DPContextMenuDirective } from './dp-context-menu.directive';

@Directive({
  selector: '[appDPEventsContextMenu]',
  standalone: false,
})
export class EventsContextMenuDirective
  extends DPContextMenuDirective<VirtualFolder, EventsContextMenuComponent>
  implements OnInit
{
  protected override readonly application = Application.calendar;
  protected override readonly stateKey = StateKey.eventsDPSidebarFilters;

  protected override registerComponent() {
    return EventsContextMenuComponent;
  }
}
